import { Select, Modal, message, Badge } from "antd";
import axios from "axios";
import { useAuth } from "../../../layout/auth";
import moment from "moment";

export default function StatusSelector(props) {
  const { verification, setVerification, id, selectedStatus, setSelectedStatus } = props;

  const auth = useAuth();

  const getEstado = (status) => {
    switch (status) {
      case 1:
        return "En proceso";
      case 2:
        return "En revisión";
      case 3:
        return "Emitido";
      case 4:
        return "Pagado";
      case 5:
        return "Cancelado";
      default:
        return "Desconocido";
    }
  };

  return (
    <Select
      value={selectedStatus}
      onChange={(value) => {
        if (auth.Rol !== "director" && value === 2) {
          // If the user is not a "director" and selects "En revisión" (value 2)
          Modal.confirm({
            title: "¿Estás seguro que quieres marcarla para revisión?",
            content: "Si la marcas para revisión, ya no podrás agregar ni cambiar información, hasta que un administrador lo permita.",
            onOk: () => {
              // If confirmed, proceed with the status update
              axios
                .put(`${process.env.REACT_APP_API_URL}/verificaciones/${verification.VerificacionID}`, {
                  ...verification,
                  Status: value,
                  FechaListo: moment().format("YYYY-MM-DD"),
                })
                .then(() => {
                  message.success("Estado actualizado");

                  // Refresh verification details
                  axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/${id}`).then((res) => {
                    setVerification(res.data[0]);
                    setSelectedStatus(value);
                  });

                  // 🔹 Notify all directors
                  axios
                    .post(`${process.env.REACT_APP_API_URL}/notificaciones/directores`, {
                      Mensaje: `La verificación ${verification.ControlInterno} está lista para registrar en SEDIVER.`,
                      Estado: 0, // Unread
                      TargetURL: `/verificaciones/${verification.VerificacionID}`,
                    })
                    .then(() => {
                      message.success("Notificación enviada a directores");
                    })
                    .catch((err) => {
                      console.error("Error enviando notificación:", err);
                    });
                })
                .catch((err) => {
                  message.error(err.message);
                });
            },
            onCancel: () => {
              // If canceled, reset the value to 1
              setSelectedStatus(1);
            },
          });
        } else {
          // If the user is a director or selects a different status, update directly
          const updatedData = {
            ...verification,
            Status: value,
          };

          if (auth.Rol === "director") {
            if (value === 2) {
              updatedData.FechaListo = moment().format("YYYY-MM-DD");
            } else if (value === 3) {
              updatedData.FechaEmision = moment().format("YYYY-MM-DD");
            } else if (value === 4) {
              updatedData.FechaPago = moment().format("YYYY-MM-DD");
            } else if (value === 5) {
              updatedData.FechaCancelacion = moment().format("YYYY-MM-DD");
            }
          }

          axios
            .put(`${process.env.REACT_APP_API_URL}/verificaciones/${verification.VerificacionID}`, updatedData)
            .then(() => {
              message.success("Estado actualizado");

              axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/${id}`).then((res) => {
                setVerification(res.data[0]);
                setSelectedStatus(value);
              });

              // 🔹 If a director changes status, notify the user who created the verification
              axios
                .post(`${process.env.REACT_APP_API_URL}/notificaciones`, {
                  UsuarioID: verification.UsuarioID, // Notify the creator
                  Mensaje: `La verificación ${verification.ControlInterno} ha cambiado de ${getEstado(verification.Status)} a ${getEstado(
                    value
                  )}.`,
                  Estado: 0, // Unread
                  TargetURL: `/verificaciones/${verification.VerificacionID}`,
                })
                .then(() => {
                  message.success("Notificación enviada al usuario");
                })
                .catch((err) => {
                  console.error("Error enviando notificación al usuario:", err);
                });
            })
            .catch((err) => {
              message.error(err.message);
            });
        }
      }}
      disabled={auth.Rol !== "director" && verification?.Status >= 2}
      style={{ width: "100%" }}
    >
      <Select.Option value={1}>
        <Badge status="default" />
        En proceso
      </Select.Option>
      <Select.Option value={2}>
        <Badge status="processing" />
        En revisión
      </Select.Option>
      <Select.Option value={3} disabled={auth.Rol !== "director"}>
        <Badge status="success" />
        Emitida (Completada)
      </Select.Option>
      <Select.Option value={5} disabled={auth.Rol !== "director"}>
        <Badge status="error" />
        Cancelado
      </Select.Option>
    </Select>
  );
}
